"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var __1 = require("../");
var Model_1 = require("../Model");
var Merchant = /** @class */ (function (_super) {
    __extends(Merchant, _super);
    function Merchant(id, name, locationId, active, timeSlotConfig, location, sendEmails, clientId, clientSecret) {
        var _this = _super.call(this, id) || this;
        _this.sendEmails = true;
        _this.fetchLocation = function () {
            return _this.fetchNestedModel("setLocation", __1.Location.fetch, "getLocationId");
        };
        _this.updateGeneralMerchantInfo = function (id, location, name) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(name || location)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Merchant.makeRequest("/delivery/functions/update-merchant/" + id, Model_1.METHOD.POST, {
                                id: id,
                                location: location,
                                name: name,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, {
                            active: this.getActive,
                            id: this.getId,
                            location: this.getLocation,
                            locationId: this.getLocationId,
                            name: this.getName,
                            timeSlotConfig: this.getTimeSlotConfig,
                        }];
                }
            });
        }); };
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            var location_1, params, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.getId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getLocation];
                    case 1:
                        location_1 = _c.sent();
                        return [4 /*yield*/, this.updateGeneralMerchantInfo(this.getId, location_1, this.getName)];
                    case 2:
                        _c.sent();
                        return [2 /*return*/, this];
                    case 3:
                        _a = {};
                        _b = {};
                        return [4 /*yield*/, this.getLocation];
                    case 4:
                        params = (_a.merchant = (_b.location = _c.sent(),
                            _b.name = this.getName,
                            _b.sendEmails = this.getSendEmails,
                            _b),
                            _a.timeSlotConfig = this.getTimeSlotConfig,
                            _a);
                        if (this.getClientId && this.getClientSecret) {
                            Object.assign(params, {
                                merchant: __assign({}, params.merchant, { v1Credentials: {
                                        clientId: this.getClientId,
                                        clientSecret: this.getClientSecret,
                                    } }),
                            });
                        }
                        return [4 /*yield*/, Merchant.makeRequest("/delivery/functions/create-merchant/", Model_1.METHOD.POST, params)];
                    case 5:
                        _c.sent();
                        return [2 /*return*/, this];
                }
            });
        }); };
        _this.setName = name;
        _this.setLocationId = locationId;
        _this.setActive = active;
        _this.setTimeSlotConfig = timeSlotConfig;
        _this.setLocation = location;
        if (sendEmails) {
            _this.setSendEmails = sendEmails;
        }
        if (clientId) {
            _this.setClientId = clientId;
        }
        if (clientSecret) {
            _this.setClientSecret = clientSecret;
        }
        return _this;
    }
    Object.defineProperty(Merchant.prototype, "getName", {
        /**
         * GETTERS
         */
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "getLocationId", {
        get: function () {
            return this.locationId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "getLocation", {
        get: function () {
            return this.checkIfPropertyIsFetched("location", this.fetchLocation);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "getActive", {
        get: function () {
            return this.active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "getTimeSlotConfig", {
        get: function () {
            return this.timeSlotConfig;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "getSendEmails", {
        get: function () {
            return this.sendEmails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "getClientId", {
        get: function () {
            return this.clientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "getClientSecret", {
        get: function () {
            return this.clientSecret;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "setName", {
        /**
         * SETTERS
         */
        set: function (name) {
            this.name = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "setLocationId", {
        set: function (locationId) {
            this.locationId = locationId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "setLocation", {
        set: function (location) {
            this.location = location;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "setActive", {
        set: function (active) {
            this.active = active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "setTimeSlotConfig", {
        set: function (config) {
            this.timeSlotConfig = config;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "setSendEmails", {
        set: function (sendEmails) {
            this.sendEmails = sendEmails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "setClientId", {
        set: function (clientId) {
            this.clientId = clientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Merchant.prototype, "setClientSecret", {
        set: function (clientSecret) {
            this.clientSecret = clientSecret;
        },
        enumerable: true,
        configurable: true
    });
    Merchant.fetchDropdownValues = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, accountManager, productCategory;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        Merchant.makeRequest("/delivery/private/account-manager/", Model_1.METHOD.GET),
                        Merchant.makeRequest("/delivery/private/product-category/", Model_1.METHOD.GET),
                    ])];
                case 1:
                    _a = _b.sent(), accountManager = _a[0], productCategory = _a[1];
                    return [2 /*return*/, {
                            accountManagers: lodash_1.get(accountManager, 'result'),
                            productCategories: lodash_1.get(productCategory, 'result'),
                        }];
            }
        });
    }); };
    Merchant.updateInvoicingSection = function (merchantId, payload) {
        return Merchant.makeRequest("/delivery/functions/update-merchant-invoicing/" + merchantId, Model_1.METHOD.PUT, payload);
    };
    Merchant.updateMerchantInfo = function (merchantId, payload) {
        return Merchant.makeRequest("/delivery/functions/update-merchant-info/" + merchantId, Model_1.METHOD.PUT, payload);
    };
    Merchant.saveNewMerchant = function (payload) {
        return Merchant.makeRequest("/delivery/functions/create-merchant", Model_1.METHOD.POST, payload);
    };
    Merchant.fetch = function (merchantId) { return __awaiter(_this, void 0, void 0, function () {
        var merchant;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Merchant.makeRequest("/delivery/private/merchant/" + merchantId, Model_1.METHOD.GET)];
                case 1:
                    merchant = (_a.sent()).result;
                    return [2 /*return*/, new Merchant(merchant.id, merchant.name, merchant.locationId, merchant.active, merchant.timeSlotConfig, merchant.location)];
            }
        });
    }); };
    Merchant.createMerchantUser = function (profile) {
        return Merchant.makeRequest('/delivery/functions/user/merchant', Model_1.METHOD.POST, profile);
    };
    Merchant.getMerchantList = function () {
        return Merchant.makeRequest('/delivery/functions/merchant', Model_1.METHOD.GET);
    };
    Merchant.getMerchants = function () {
        return Merchant.makeRequest("/delivery/functions/get-merchants", Model_1.METHOD.GET);
    };
    Merchant.fetchMerchantOverview = function (merchantId) {
        return Merchant.makeRequest("/delivery/functions/fetch-merchant-overview/" + merchantId, Model_1.METHOD.GET);
    };
    /**
     * Retrieves the merchant collection for the currently logged in merchant.
     * @returns {Promise<IMerchantCollection>} The merchant upcoming merchant collection.
     */
    Merchant.getMerchantCollection = function () {
        return Model_1.Model.makeRequest('/delivery/functions/merchant/collection', Model_1.METHOD.GET);
    };
    /**
     * Verifies the drivers ID card number on the back-end.
     * @param {number} collectionId The collection id to verify for.
     * @param {string} idCardNo The ID card number.
     * @returns {Promise<boolean>} Whether the verification was successful.
     */
    Merchant.verifyDriver = function (collectionId, idCardNo) { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Model_1.Model.makeRequest('/delivery/functions/merchant/collection/verification', Model_1.METHOD.POST, { collectionId: collectionId, recordedCardId: idCardNo })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    Merchant.fetchMerchantForecasts = function (merchantId) {
        return Merchant.makeRequest("/delivery/functions/merchant/" + merchantId + "/shipment-forecast", Model_1.METHOD.GET);
    };
    Merchant.updateMerchantForecast = function (merchantId, payload) {
        return Merchant.makeRequest("/delivery/functions/merchant/" + merchantId + "/shipment-forecast", Model_1.METHOD.POST, payload);
    };
    return Merchant;
}(Model_1.Model));
exports.Merchant = Merchant;
